import * as React from 'react';
import { Loader, Box, Text, Icon } from '@openfin/ui-library';
import styled from 'styled-components';

interface MessageCardProps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const MessageCard = ({ children, title, subtitle }: MessageCardProps): JSX.Element => (
  <CardContainer>
    {children}
    {title && <Text size="xlarge">{title}</Text>}
    {subtitle && <Text>{subtitle}</Text>}
  </CardContainer>
);

export const EmptyNotificationListCard = (): JSX.Element => (
  <MessageCard title="No Notifications" subtitle="You're up to date!">
    <MessageIcon size="xxlarge" icon="BellIcon" />
  </MessageCard>
);

export const EmptyResultsListCard = (props: { query: string }): JSX.Element => (
  <MessageCard title={`No results for "${props.query}"`} subtitle="Please try again.">
    <MessageIcon size="xxlarge" icon="CrossCircledIcon" />
  </MessageCard>
);

export const LoadingCard = ({ message = 'Loading' }: { message: string }): JSX.Element => (
  <MessageCard title={message}>
    <Loader size="xxlarge" />
  </MessageCard>
);

const CardContainer = styled(Box)`
  align-items: center;
  background: ${({ theme }) => theme.palette.background4};
  border-radius: ${({ theme }) => theme.radius.base};
  box-shadow: ${({ theme }) => theme.shadow.base};
  flex-direction: column;
  justify-content: center;
  margin: 0px ${({ theme }) => theme.px.small};
  min-height: 128px;
  padding: ${({ theme }) => theme.px.xxlarge};
  text-align: center;
  user-select: none;
  width: 312px;
`;

const MessageIcon = styled(Icon)`
  margin-bottom: ${({ theme }) => theme.px.base};
`;
